export default __webpack_public_path__ + "static/media/GUARANTEE_STICKER.3c2e33a5.png";